import React from 'react';
import { createRoot } from 'react-dom/client';

import { Provider } from 'react-redux';
import { store } from './app/store';

import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import reportWebVitals from './reportWebVitals';
import './index.css';

import App from './app/App';
import Home from './features/home/Home';
import Account from './features/account/Account';
import Transfer from './features/transfer/Transfer';
import AccountInfo from './components/accountInfo/AccountInfo';
import Login from './features/login/Login';
import Settings from './components/settings/Settings';
import EditDisplayNameForm from './features/editDisplayNameForm/EditDisplayNameForm';
import ChangePasswordForm from './features/changePasswordForm/ChangePasswordForm';
import DepositForm from './features/depositForm/DepositForm';
import ManageUsers from './features/manageUsers/ManageUsers';
import ManageBranches from './features/manageBranches/ManageBranches';
import ManageAccounts from './features/manageAccounts/ManageAccounts';
import ManageBankSettings from './features/manageBankSettings/ManageBankSettings';
import DepositConfirmation from './components/depositConfirmation/DepositConfirmation';
import TransferConfirmation from './components/transferConfirmation/TransferConfirmation';
import WithdrawalForm from './features/withdrawalForm/WithdrawalForm';
import WithdrawalConfirmation from './components/withdrawalConfirmation/WithdrawalConfirmation';
import Statements from './features/statements/Statements';
import SupportTickets from './features/supportTickets/SupportTickets';
import LandingPage from './components/landingPage/LandingPage';
import SignUp from './features/signup/Signup';
import ManageBanks from './features/manageBanks/ManageBanks';

const container = document.getElementById('root');
const root = createRoot(container);

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "",
        element: <LandingPage />
      },
      {
        path: "login",
        element: <Login />
      },
      {
        path: "signup",
        element: <SignUp />
      },
      {
        path: "home",
        element: <Home />
      },
      {
        path: "account/:accountId",
        element: <Account />
      },
      {
        path: ":bankId/transfer",
        element: <Transfer />
      },
      {
        path: ":bankId/transfer/confirmation",
        element: <TransferConfirmation />
      },
      {
        path: "settings/accountInfo",
        element: <AccountInfo />
      },
      {
        path: "settings",
        element: <Settings />
      },
      {
        path: "settings/editDisplayName",
        element: <EditDisplayNameForm />
      },
      {
        path: "settings/updatePassword",
        element: <ChangePasswordForm />
      },
      {
        path: ":bankId/deposit",
        element: <DepositForm />
      },
      {
        path: ":bankId/withdrawal",
        element: <WithdrawalForm />
      },
      {
        path: ":bankId/deposit/confirmation",
        element: <DepositConfirmation />
      },
      {
        path: ":bankId/withdrawal/confirmation",
        element: <WithdrawalConfirmation />
      },
      {
        path: ":bankId/admin/users",
        element: <ManageUsers />
      },
      {
        path: "admin/banks",
        element: <ManageBanks />
      },
      {
        path: ":bankId/admin/branches",
        element: <ManageBranches />
      },
      {
        path: ":bankId/admin/accounts",
        element: <ManageAccounts />
      },
      {
        path: "documents/statements",
        element: <Statements />
      },
      {
        path: ":bankId/admin/bank",
        element: <ManageBankSettings />
      },
      {
        path: ":bankId/support",
        element: <SupportTickets />
      }
    ]
  }
])

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
